// src/utils/rbac.js
// Role-Based Access Control utilities

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  LAWYER: 'lawyer',
  CLIENT: 'client'
};

export const PERMISSIONS = {
  MANAGE_CASE_STUDIES: 'manage_case_studies',
  VIEW_ALL_USERS: 'view_all_users',
  MANAGE_LAWYERS: 'manage_lawyers',
  ACCESS_ADMIN_PANEL: 'access_admin_panel',
  VIEW_OWN_PROFILE: 'view_own_profile',
  EDIT_OWN_PROFILE: 'edit_own_profile',
  VIEW_LAWYERS: 'view_lawyers',
  BOOK_LAWYER: 'book_lawyer',
  VIEW_CASE_STUDIES: 'view_case_studies'
};

const rolePermissions = {
  super_admin: [
    PERMISSIONS.MANAGE_CASE_STUDIES,
    PERMISSIONS.VIEW_ALL_USERS,
    PERMISSIONS.MANAGE_LAWYERS,
    PERMISSIONS.ACCESS_ADMIN_PANEL,
    PERMISSIONS.VIEW_CASE_STUDIES,
    PERMISSIONS.VIEW_LAWYERS
  ],
  lawyer: [
    PERMISSIONS.VIEW_OWN_PROFILE,
    PERMISSIONS.EDIT_OWN_PROFILE,
    PERMISSIONS.VIEW_CASE_STUDIES,
    PERMISSIONS.VIEW_LAWYERS
  ],
  client: [
    PERMISSIONS.VIEW_LAWYERS,
    PERMISSIONS.BOOK_LAWYER,
    PERMISSIONS.VIEW_CASE_STUDIES,
    PERMISSIONS.VIEW_OWN_PROFILE,
    PERMISSIONS.EDIT_OWN_PROFILE
  ]
};

/**
 * Check if a user has a specific permission
 */
export const hasPermission = (userRole, permission) => {
  if (!userRole || !rolePermissions[userRole]) {
    return false;
  }
  return rolePermissions[userRole].includes(permission);
};

/**
 * Check if a user has any of the provided permissions
 */
export const hasAnyPermission = (userRole, permissions) => {
  return permissions.some(permission => hasPermission(userRole, permission));
};

/**
 * Check if a user has all of the provided permissions
 */
export const hasAllPermissions = (userRole, permissions) => {
  return permissions.every(permission => hasPermission(userRole, permission));
};

/**
 * Check if a user has a specific role
 */
export const hasRole = (userRole, requiredRole) => {
  if (Array.isArray(requiredRole)) {
    return requiredRole.includes(userRole);
  }
  return userRole === requiredRole;
};

/**
 * Format role for display
 */
export const formatRole = (role) => {
  const roleMap = {
    super_admin: 'Super Admin',
    lawyer: 'Lawyer',
    client: 'Client'
  };
  return roleMap[role] || role;
};
